import React from 'react';
import { CHECKOUT_URL } from '../data/atlante';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL} className={`block w-full rounded-lg border-b-4 border-[#1B7B32] bg-green px-4 py-3 text-center font-display text-sm font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg
        transition-[background-color,transform,box-shadow] duration-150 ease-soft
        hover:-translate-y-0.5 hover:bg-[#2fbb50] active:translate-y-0 active:border-b-2
        focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold
        sm:text-base ${className}`} data-id="element-30" data-mp="2kzpq72mht3n3">
      {children}
    </a>;
}